import queryString from 'query-string';

import { UserMini } from 'api/types/shared.types';
import { APPLICATION_STATUSES_ALL } from 'utils/constants/ats';
import { getJson, postJson } from 'utils/http';

export type ListingApplicationType = 'JOB' | 'INTERNSHIP' | 'VOLOP';
export type ListingApplicationStatus = keyof typeof APPLICATION_STATUSES_ALL;
type ListingMini = {
  id: string;
  name: string;
  type: ListingApplicationType;
  firstPublished?: string;
};
type ListingApplicationFeedEntryBase = {
  id: string;
  created: string;
  byUser: UserMini | null | undefined;
};
export type LisitngApplicationFeedNote = ListingApplicationFeedEntryBase & {
  type: 'ADDED_NOTE';
  data: {
    note: string;
  };
};
export type ListingApplicationFeedStatus = ListingApplicationFeedEntryBase & {
  type: 'STATUS_CHANGED';
  data: {
    prevStatus: ListingApplicationStatus | null | undefined;
    newStatus: ListingApplicationStatus;
  };
};
export type ListingApplicationFeedEntry =
  | LisitngApplicationFeedNote
  | ListingApplicationFeedStatus;
export type ListingApplicationMini = {
  id: string;
  created: string;
  status: ListingApplicationStatus;
  user: UserMini;
  listing: ListingMini;
  lastFeedEntry: ListingApplicationFeedEntry | null | undefined;
};
export type File = {
  filename: string;
  id: string;
  mimetype: string;
  size: number;
};
export type FileAttachment = {
  type: 'FILE';
  file: File;
  label: string;
};
export type UrlAttachment = {
  type: 'URL';
  label: string;
  url: string;
};
export type ApplicantQuestion = {
  label: string;
  text: string;
  type: 'TEXT';
};
export type ListingSuggestedApplicant = {
  adminNotifications?: Array<{
    fromUserId: string;
    replyTo: Array<string>;
    sent: string;
  }>;
  id: string;
  jobTitle: string;
  location: string;
  name: string;
  resumeUploaded: string;
  updatedByUser: string;
  views: Array<string>;
};
export type ListingApplication = {
  id: string;
  created: string;
  user: UserMini;
  status: ListingApplicationStatus;
  listing: ListingMini;
  feedEntries: Array<ListingApplicationFeedEntry>;
  files: {
    resume: File;
    requestedAttachments: Array<{
      file: File;
      label: string;
    }>;
  };
  referrer: string | null | undefined;
  attachments: {
    resume: File;
    requestedAttachments: Array<
      FileAttachment | UrlAttachment | ApplicantQuestion
    >;
  };
  suggestedApplicant?: ListingSuggestedApplicant;
};
export const fetchApplications = (
  orgId: string,
  params: {
    type: ListingApplicationType | null | undefined;
    id: string | null | undefined;
  }
) => {
  const qs = queryString.stringify(params);
  return getJson(`/data/orgdashboard/${orgId}/listing-applications?${qs}`);
};
export const fetchApplicationIds = (
  orgId: string,
  params: {
    id: string | null | undefined;
  }
) => {
  const qs = queryString.stringify(params);
  return getJson(
    `/data/orgdashboard/${orgId}/listing-applications-ids?${qs}`
    // @ts-expect-error TS(2345): Argument of type '({ listingApplicationIds }: { li... Remove this comment to see the full error message
  ).then(({ listingApplicationIds }) => listingApplicationIds);
};
export const fetchApplication: (arg0: {
  orgId: string;
  applicationId: string;
}) => Promise<ListingApplication> = ({ orgId, applicationId }) =>
  getJson(
    `/data/orgdashboard/${orgId}/listing-applications/${applicationId}`
    // @ts-expect-error TS(2345): Argument of type '({ listingApplication }: { listi... Remove this comment to see the full error message
  ).then(({ listingApplication }) => listingApplication);
export type RequestedAttachmentType =
  | {
      type: 'FILE';
      s3FileId: string;
    }
  | {
      type: 'URL';
      url: string;
    };
export type ListingApplicationPayload = {
  id: string;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  email: string | null | undefined;
  requestedAttachments: Array<RequestedAttachmentType>;
  requestedAttachmentsHash: string;
  resumeS3FileId?: string;
  replaceCurrentResume: boolean;
  type: ListingApplicationType;
  consentAts?: boolean;
};
export const createApplication = (payload: ListingApplicationPayload) =>
  postJson('/data/listing-applications', payload).then((response) => response);
export const createApplicationNote: (arg0: {
  note: string;
  orgId: string;
  applicationId: string;
}) => Promise<ListingApplication> = ({ orgId, applicationId, ...data }) =>
  postJson(
    `/data/orgdashboard/${orgId}/listing-applications/${applicationId}/note`,
    data
    // @ts-expect-error TS(2345): Argument of type '({ listingApplication }: { listi... Remove this comment to see the full error message
  ).then(({ listingApplication }) => listingApplication);
export const updateApplicationStatus: (arg0: {
  status: ListingApplicationStatus;
  orgId: string;
  applicationId: string;
}) => Promise<ListingApplication> = ({ orgId, applicationId, ...data }) =>
  postJson(
    `/data/orgdashboard/${orgId}/listing-applications/${applicationId}/status`,
    data
    // @ts-expect-error TS(2345): Argument of type '({ listingApplication }: { listi... Remove this comment to see the full error message
  ).then(({ listingApplication }) => listingApplication);
export function validateApplication(
  payload: Record<string, any>, // eslint-disable-line @typescript-eslint/no-explicit-any
  params?: {
    partial: boolean;
  }
): Promise<{
  listingApplication: ListingApplicationPayload;
}> {
  // @ts-expect-error TS(2345): Argument of type '{ partial: boolean; } | undefine... Remove this comment to see the full error message
  const qs = queryString.stringify(params);
  return postJson(
    `/data/listing-applications-validation${qs ? `?${qs}` : ''}`,
    payload
  );
}
